<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="ModalTopicToInsight"
    title="Add Topics to Insight"
    submit-name="Add"
    full-height
    disable-tabindex
    :submit-disabled="dataError || !selected"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="!dataError">
      <lm-logo v-if="!insights || !currentLandscape" />
      <template v-else>
        <lm-label>Topics selected: {{ numTopicsSelected }}</lm-label>
        <div class="flex items-center justify-between pb-4 border-b">
          <lm-label no-margin>Select an Insight</lm-label>
          <lm-search
            v-model="search"
            class="SearchUsers"
            placeholder="Search by title"
            @close="search = ''"
          />
        </div>
        <ul class="InsightList">
          <li
            v-for="insight in filteredInsights"
            :key="insight._id"
            class="flex items-center justify-between flex-wrap border-b py-3 hover:bg-highlightBaseLight hover:-mx-6 hover:px-6 cursor-pointer"
            :class="{
              'bg-highlightBaseLight -mx-6 px-6': selected === insight._id
            }"
            @click="selected = insight._id"
          >
            <lm-title size="m">{{ insight.key }}. {{ insight.title }}</lm-title>
            <lm-icon
              v-if="insight.currentUser.favorited"
              icon="star"
              size="21"
            />
            <lm-summary-meta
              :username="getAuthorName(insight.author)"
              :created-at="insight.createdAt"
              class="w-full"
            />
          </li>
        </ul>
      </template>
    </template>
  </form-modal>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
import LmLabel from '@/components/ui/LmLabel'
import LmLogo from '@/components/ui/LmLogo'
import LmSearch from '@/components/ui/LmSearch'
import LmSummaryMeta from '@/components/ui/summary/LmSummaryMeta'
import LmTitle from '@/components/ui/text/LmTitle'
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import {orderBy} from 'lodash'

export default {
  name: 'ModalTopicToInsight',
  components: {
    LmLabel,
    LmLogo,
    LmIcon,
    LmSummaryMeta,
    LmTitle,
    LmSearch,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.TOPIC_TO_INSIGHT,
      search: '',
      selected: null,
      modalRef: null,
      dataError: false
    }
  },
  computed: {
    ...mapGetters([
      'currentLandscape',
      'currentTopic',
      'userId',
      'getUserByID',
      'bulkTopics'
    ]),
    ...mapGetters({insights: 'insights/insights'}),
    numTopicsSelected() {
      return this.bulkTopics.length
    },
    filteredInsights() {
      if (this.search === '') return this.sortInsights(this.insights)
      return this.sortInsights(
        this.insights.filter(insight =>
          insight.title.toLowerCase().includes(this.search.toLowerCase())
        )
      )
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.loadInsights()
  },
  methods: {
    loadInsights() {
      if (this.currentLandscape) {
        this.$store.dispatch('insights/load')
      } else {
        this.dataError = true
      }
    },
    getAuthorName(userId) {
      return this.getUserByID(userId).username
    },
    sortInsights(insights) {
      return orderBy(
        insights,
        ['currentUser.favorited', 'createdAt'],
        ['desc', 'desc']
      )
    },
    submit() {
      if (this.selected) {
        const payload = {
          insightId: this.selected,
          topics: this.bulkTopics
        }
        this.$store
          .dispatch('insights/addTopic', payload)
          .then(insight => {
            const n = this.numTopicsSelected
            const topic = this.$options.filters.pluralizeWord('Topic', n)
            const msg = `${n} ${topic} added to Insight`
            EventHub.emit(
              Events.SHOW_SNACKBAR,
              msg,
              'View Insight',
              this.viewInsight,
              insight.slug
            )
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        document.querySelector('.ModalTopicToInsight .Modal-body').scrollTop = 0
        this.modalRef.submitFails()
      }
    },
    viewInsight(slug) {
      this.$router.push({
        name: 'insight',
        params: {insightSlug: slug}
      })
    },
    modalClosed() {
      this.$store.commit('resetBulkTopics')
    }
  }
}
</script>
